<div class="layoutBlock">
	<div class="columnThreeQuarter">
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>
		
		<res-edit-right-of-use-right 
            [researchContracts]="patent.researchContracts" 
			[hisDynamicContent]="'fs.res.patent.Patent.rightsOfUse'" 
			[dynamicComponent]="patent._dynamicComponent"
			(researchContractChange)="researchContractChange($event)">
		</res-edit-right-of-use-right>
	
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>
		
		<res-research-contract-incomes 
            [hisDdKeyPrefix]="'fs.res.finance.ResearchContract_patent'"
            [(researchContracts)]="patent.researchContracts"
			[dynamicComponent]="patent._dynamicComponent"
            [hisDynamicContent]="'fs.res.common.finance.researchContract.income'" 
			infoAssignmentReceipts="fs.res.common.finance.researchContract.rightOfUse.infoAssignmentIncomes">
		</res-research-contract-incomes>
		
		<!-- #anchor dynamic field container -->	
		<ng-template #dynamicFieldSetContainer></ng-template>
	</div>
</div>
